/* eslint-disable */
import get from 'lodash.get';
import isBoolean from 'lodash.isboolean';
import isObject from 'lodash.isobject';
import dayjs from 'dayjs';
import dayjsUtcPlugin from 'dayjs/plugin/utc';
import BaseAuction from './BaseAuction';
import { isUndefinedOrNullOrEmpty } from '@/utilities';
import LaneInfo from './LaneInfo';

dayjs.extend(dayjsUtcPlugin);

export default class Auction extends BaseAuction {
  constructor(auction, user) {
    // Handle API discrepancies between lists and single get - ETC
    if (auction.odometer) {
      auction.odometer = parseInt(auction.odometer.toString().replace(/,/g, ''), 10);

    }
    if (!auction.high_bid && auction.bid_amount) {
      const user_id = parseInt(get(auction, 'buyer_info.user_id'), 10);
      const dealer_id = parseInt(get(auction, 'buyer_info.dealer_id'), 10);
      auction.high_bid = {
        amount: auction.bid_amount,
        user_id,
        dealer: {
          id: dealer_id,
        }
      }
    }
    if (!isObject(auction.seller) && auction.seller_info) {
      const userId = parseInt(get(auction, 'seller_info.user_id'), 10);
      const dealerId = parseInt(get(auction, 'seller_info.dealer_id'), 10);
      auction.seller = {
        user: {
          id: userId,
        },
        dealer: {
          id: dealerId,
        }
      }

      // store seller name for later.  some endpoint responses omit this stringi90--]890--  -
      if (user && Object.keys(user.dealerships).includes(dealerId.toString())) {
        auction.seller.dealer.name = user.dealerships[dealerId].name;
      }
    }

    if (!auction.last_negotiation_bid && auction.negotiations) {
      const lastNegotiationDealerId = parseInt(get(auction, 'negotiations.last_dealer'), 10);
      const lastNegotiationUserId = parseInt(get(auction, 'negotiations.last_user'), 10);
      const lastNegotiationBuyerAmount = parseInt(get(auction, 'negotiations.buyer_amount'), 10);
      const lastNegotiationSellerAmount = parseInt(get(auction, 'negotiations.seller_amount'), 10);
      const auctionSellerUserId = parseInt(get(auction, 'seller_info.user_id'), 10);
      auction.last_negotiation_bid = {
        dealer_id: lastNegotiationDealerId,
        user_id: lastNegotiationUserId,
      }
      if (lastNegotiationUserId === auctionSellerUserId) {
        auction.last_negotiation_bid.amount = lastNegotiationSellerAmount;
      } else {
        auction.last_negotiation_bid.amount = lastNegotiationBuyerAmount;
      }

      if (user) {
        if (user.id === auctionSellerUserId) {
          auction.last_negotiation_bid.ourOffer = lastNegotiationSellerAmount;
          auction.last_negotiation_bid.theirOffer = lastNegotiationBuyerAmount;
        }
        else {
          auction.last_negotiation_bid.ourOffer = lastNegotiationBuyerAmount;
          auction.last_negotiation_bid.theirOffer = lastNegotiationSellerAmount;
        }
      }
    }

    if (!auction.vehicle_name) {
      auction.vehicle_name = auction.vehicle_display_name;
    }

    if (!auction.high_bid) {
      auction.high_bid = {
        amount: null,
        user_id: null,
        dealer: {},
      };
    }

    if (!auction.last_negotiation_bid) {
      auction.last_negotiation_bid = {
        amount: null,
        ourOffer: null,
        theirOffer: null,
      }
    }

    super(auction);
    this.auction.lastUpdated = dayjs();
  }

  get sellerDealerId() {
    return get(this.auction, 'seller.dealer.id');
  }

  set sellerDealerId(sellerDealerId) {
    this.auction.seller.dealer.id = this.validateNumber(sellerDealerId);
  }

  get buyerDealerId() {
    return get(this.auction, 'high_bid.dealer.id') || get(this.auction, 'high_bid.dealer.dealer_id') || get(this.auction, 'buyer_info.dealer_id');
  }

  get buyerUserId() {
    return get(this.auction, 'high_bid.user_id');
  }

  get endTime() {
    if(dayjs(this.auction.end_time, 'YYYY-MM-DD HH:mm:ss', true).isValid()) {
      return dayjs.utc(this.auction.end_time);
    }

    return dayjs.unix(get(this.auction, 'end_time')).utc();
  }

  get eulaAccepted() {
    return get(this.auction, 'eula_accepted');
  }

  set endTime(endTime) {
    if (dayjs(endTime, 'YYYY-MM-DD HH:mm:ss', true).isValid()) {
      this.auction.end_time = dayjs.utc(endTime) * 1000;
    } else {
      this.auction.end_time = parseInt(endTime, 10);
    }
  }

  get bidCount() {
    return get(this, 'auction.bid_count') || 0;
  }

  set bidCount(bidCount) {
    this.auction.bid_count = parseInt(bidCount, 10) || 0;
  }

  get viewCount() {
    return get(this.auction, 'view_count', 0);
  }

  set viewCount(viewCount) {
    this.auction.view_count = viewCount;
  }

  get hasBids() {
    return !isUndefinedOrNullOrEmpty(get(this, 'highBid'));
  }

  get pendingOffer() {
    return get(this.auction, 'pending_offer');
  }

  get hasPendingOffer() {
    return !isUndefinedOrNullOrEmpty(this.pendingOffer);
  }

  get startPrice() {
    return get(this.auction, 'start_price');
  }

  get highBid() {
    return get(this.auction, 'high_bid');
  }

  set highBid(highBid) {
    this.auction.high_bid = highBid;
  }

  get highBidAmount() {
    return get(this.auction, 'high_bid.amount');
  }

  set highBidAmount(highBid) {
    this.auction.high_bid.amount = this.validateNumber(highBid);
  }

  get highBidUserId() {
    return get(this.auction, 'high_bid.user_id') || get(this.auction, 'buyer_info.user_id');
  }

  set highBidUserId(highBidUserId) {
    this.auction.high_bid.user_id = this.validateNumber(highBidUserId);
  }

  set highBidDealerId(highBidDealerId) {
    if (!this.auction.high_bid.dealer) {
      this.auction.high_bid.dealer = {};
    }

    this.auction.high_bid.dealer.id = highBidDealerId;
  }

  get currentBidAmount() {
    return this.highBidAmount || this.startPrice;
  }

  get lastNegotiationBid() {
    return get(this.auction, 'last_negotiation_bid');
  }

  get lastNegotiationBidAmount() {
    return get(this.auction, 'last_negotiation_bid.amount');
  }

  get lastNegotiationBidUserId() {
    return get(this.auction, 'last_negotiation_bid.user_id');
  }

  get lastNegotiationBidDealerId() {
    return get(this.auction, 'last_negotiation_bid.dealer_id');
  }

  get odometer() {
    return get(this.auction, 'odometer');
  }

  set odometer(odometer) {
    this.auction.odometer = odometer;
  }

  get isParticipant() {
    return get(this.auction, 'participant', false);
  }

  set isParticipant(isParticipant) {
    this.auction.participant = isBoolean(isParticipant) ? isParticipant : parseInt(isParticipant) === 1;
  }

  get isRelaunchable() {
    return get(this.auction, 'relaunchable', false);
  }

  get isAutoSell() {
    return get(this.auction, 'autosell', true);
  }

  get isScheduled() {
    return get(this.auction, 'is_scheduled', false);
  }

  get lastUpdated() {
    return get(this.auction, 'lastUpdated');
  }

  set lastUpdated(lastUpdated) {
    this.auction.lastUpdated = lastUpdated;
  }

  get lastBidWasProxy() {
    return get(this.auction, 'lastBidWasProxy', false);
  }

  set lastBidWasProxy(lastBidWasProxy) {
    this.auction.lastBidWasProxy = lastBidWasProxy;
  }

  get bidAmount() {
    return get(this.auction, 'bid_amount');
  }

  get laneId() {
    return get(this.auction, 'lane_id', this.laneInfo?.id);
  }

  get isPrivateAuction() {
    return this.auction.is_private || !!this.laneId;
  }

  get isPrivateAuctionWithoutConditionReport() {
    return this.isPrivateAuction
      && !this.auction?.has_complete_cr;
  }

  get hasCompleteConditionReport() {
    return this.auction?.has_complete_cr;
  }

  get laneInfo() {
    return new LaneInfo(this.auction.lane_info, this.eulaAccepted);
  }

  get negotiationInfo() {
    if (this.auction.negotiation_info) {
      const {
        last_offer: lastOffer,
        last_offer_user_id: lastOfferUserId,
        our_offer: ourOffer,
        their_offer: theirOffer,
      } = this.auction.negotiation_info;

      return {
        lastOffer,
        lastOfferUserId,
        ourOffer,
        theirOffer,
      };
    }

    return {
      lastOffer: this.lastNegotiationBidAmount,
      lastOfferUserId: this.lastNegotiationBidUserId
    };
  }

  get canBid() {
    return this.auction.can_bid ||this.laneInfo?.can_bid;
  }

  get canBuy() {
    return this.auction.can_buy && this.laneInfo?.can_buy;
  }

  get canFinalize() {
    return this.auction.can_finalize;
  }

  get canMakeOffer() {
    return this.auction.can_make_offer || this.laneInfo?.can_make_offer;
  }

  get canNegotiate() {
    return this.auction.can_negotiate;
  }

  get canDownloadBillOfSales() {
    return this.auction.can_download_bill_of_sales;
  }

  set canDownloadBillOfSales(canDownload) {
    this.auction.can_download_bill_of_sales = canDownload;
  }

  get canEditPersistentProxy() {
    return this.auction.can_edit_persistent_proxy;
  }

  get canProxyBid() {
    return this.auction.can_proxy_bid || this.laneInfo?.canProxyBid;
  }

  get canPurchaseNow() {
    return this.auction.can_purchase_now || this.laneInfo?.canPurchaseNow;
  }

  get canRemoveReserve() {
    return this.auction.can_remove_reserve || this.laneInfo?.canRemoveReserve;
  }

  get canRelaunchAuction() {
    return this.auction.can_relaunch_auction;
  }

  get dealershipMemberBids() {
    return this.auction.dealership_member_bids;
  }

  get hasActiveProxy() {
    return this.auction.has_active_proxy;
  }

  get lanePhase() {
    return this.auction.private_auction_phase || this.laneInfo?.phase;
  }

  get lanePermissionType() {
    return this.auction.lane_permission_type || this.laneInfo?.permissionType;
  }

  get makeOfferEndTime() {
    return this.auction.private_auction_make_offer_end_time || this.laneInfo?.makeOfferEndTime;
  }

  get purchaseNowEnabled() {
    return this.auction.purchase_now_enabled || this.laneInfo?.purchaseNowEnabled;
  }

  get allowBidding() {
    return this.auction.allow_bidding || this.laneInfo?.allowBidding;
  }

  get inMultifunctionalBiddingLane() {
    return this.auction.is_multifunctional_bidding;
  }

  get showReserve() {
    return this.auction.show_reserve || this.laneInfo?.showReserve;
  }

  get previewShowStartPrice() {
    return this.auction.preview_show_start_price || this.laneInfo?.previewShowStartPrice;
  }

  get hideBidsViewsVdp() {
    return this.laneInfo?.hideBidsViewsVdp
  }

  get hideAcvEstimateVdp() {
    return this.laneInfo?.hideAcvEstimateVdp
  }

  set bidAmount(bidAmount) {
    this.auction.bid_amount = bidAmount;
  }

  get acvInspected() {
    return get(this.auction, 'acv_inspected');
  }

  set acvInspected(acvInspected) {
    this.auction.acv_inspected = acvInspected;
  }

  get acvInspectedAndCompleteConditionReport() {
    return this.acvInspected && this.hasCompleteConditionReport;
  }

  get isMemberOfTopBiddingDealership() {
    return this.auction.is_member_of_top_bidding_dealership;
  }

  get isMemberOfSellingDealership() {
    return this.auction.is_member_of_selling_dealership;
  }

  get isPrimaryTopBidder() {
      return this.auction.is_primary_top_bidder;
  }

  get listedByACVCertifiedIndependentDealer() {
    return get(this.auction, 'seller_info.dealership_type') === 4;
  }

  get savedAuctionId() {
    return get(this.auction, 'saved_auction_id');
  }

  get mandatedTransport() {
    return get(this.auction, 'mandated_transport') ?? false;
  }

  lastBidWasUsers(userId) {
    if (this.lastNegotiationBidUserId) {
      return this.lastNegotiationBidUserId === userId;
    }

    return  this.highBidUserId == userId;
  }

  lastNegotiationOfferWasOurs(user) {
      return this.lastNegotiationBidUserId === user.id
        || user.isMemberOfDealership(this.lastNegotiationBidDealerId);
  }

  updateAuctionFromGetStatus(auctionStatus) {
    /* Example Response from get status - ETC
      {
        "auction_status": "active",
        "high_bidder": null,
        "high_bid_info": {
          amount: "9100"
          dealer_id: "4534"
          user_id: "1727"
        },
        "bid_amount": null,
        "view_count": 0,
        "listed_by_vci": false,
        "proxy_amount": null,
        "bid_count": "0",
        "seller_info": {
          "dealer_id": "6",
          "user_id": "670"
        },
        "auction_active": "1",
        "end_time": "1540304289",
        "unique_bidders": "0",
        "participant": 0,
        "seller": "670"
      }
    */

    this.status = auctionStatus.auction_status;
    this.isParticipant = auctionStatus.participant;
    if (this.bidCount !== auctionStatus.bid_count) {
      this.lastBidWasProxy = false;
    }
    this.bidCount = auctionStatus.bid_count;
    this.viewCount = auctionStatus.view_count;
    this.endTime = auctionStatus.end_time;
    this.highBidDealerId = parseInt(get(auctionStatus, 'high_bid_info.dealer_id'), 10);
    const highBidUserId = parseInt(get(auctionStatus, 'high_bid_info.user_id'), 10);
    const highBidAmount = parseInt(get(auctionStatus, 'high_bid_info.amount'), 10);
    if (!isNaN(highBidUserId)) {
      this.highBidUserId = highBidUserId;
    }

    if (!isNaN(highBidAmount)) {
      this.highBidAmount = highBidAmount;
    }
  }

  get postAuctionData() {
    return get(this.auction, 'post_auction_data');
  }

  get postAuctionDataPaymentMethod() {
    const paymentMethod = this.postAuctionData?.payment_method;
    if (typeof paymentMethod === 'string') {
      return paymentMethod.toLowerCase();
    }

    return '';
  }

  get userLostTopBid() {
    return this.auction.user_lost_top_bid;
  }

  get userHasExistingRunListProxy() {
    return !isUndefinedOrNullOrEmpty(this.proxyBid)
    && this.auction.status === 'run_list';
  }

  get negotiationDuration() {
    return this.auction.negotiation_end_time;
  }

  get vehiclePackageInfo() {
    return get(this.auction, 'vehicle_package_info', {}) || {};
  }

  get listingSnapshotYear() {
    return get(this.auction, 'listing_snapshot_year', null);
  }

  updateAuctionFromBidResponse(auction, currentUserId) {
    this.status = get(auction, 'auctionStatus');
    this.bidCount = get(auction, 'bidCount', 0);
    this.endTime = get(auction, 'endTime');
    this.highBidUserId = get(auction, 'highBidInfo.userId');
    this.highBidDealerId = get(auction, 'highBidInfo.dealerId');
    this.highBidAmount = get(auction, 'highBidInfo.amount');
    this.isParticipant = get(auction, 'participant');
    if (isUndefinedOrNullOrEmpty(this.proxyBid)) {
      this.proxyBid = {};
    }
    this.proxyBidAmount = get(auction, 'proxyBid.amount');
    this.proxyBidIsPersistent = get(auction, 'proxyBid.isPersistent');
    this.viewCount = get(auction, 'viewCount');
    this.lastBidWasProxy = this.highBidUserId !== currentUserId;
  }
}
